'use client';

import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

import { UnauthMutation } from '@/api';
import { useGuest } from '@/app/_hooks/useGuest';
import type { ViewContentsType } from '@/app/donation/types';
import { useAuthStore } from '@/stores/AuthStore';

interface ViewCounterProps {
  type: ViewContentsType;
  contentId: string;
}

export const ViewCounter = ({ type, contentId }: ViewCounterProps) => {
  const myInfo = useAuthStore((state) => state.myInfo);
  const { getGuestSessionId } = useGuest();
  const isCounting = useRef(false);

  const { mutate: postHomeLoveView } = useMutation({
    ...UnauthMutation['post:/wello/v2/allows/home-love-view'](),
  });

  useEffect(() => {
    if (myInfo === undefined) return;
    if (isCounting.current) return;

    const memberOAuth = myInfo?.memberOAuth;

    const userKey = memberOAuth ? memberOAuth.toString() : getGuestSessionId();

    if (!userKey) {
      return;
    }

    postHomeLoveView({
      body: {
        contentsType: type,
        contentId: contentId,
        userKey: userKey,
      },
    });

    isCounting.current = true;
  }, [myInfo, postHomeLoveView, type, contentId, getGuestSessionId]);

  return null;
};
